import LoopFront from "loop-front";

const CustomActivities = {
    TOGGLE_PUBLISH: 'publish'
}

export class Section extends LoopFront<{}, {}, typeof CustomActivities> {
    constructor() {
        super('sections', {}, {}, CustomActivities);
    }
}

export const OSection = new Section();